<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"><img alt="" height="129" src="images/fviii-01.jpg" width="224"/></span></p>
<p class="centers">Spikenard and myrrh – the anointing oils</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062059789_Frontmatter_2.vue?4ed5e46b